import {Utils} from "jboot-env";
// import townList from "@/assets/map/town/list";

export default function(http) {
    return {

        queryAllData (data){
            return http.postJson('/big/front/queryAllData', data, {loading: false});
        },

        queryBaseData (data){
            return http.postJson('/big/front/queryBaseData', data, {loading: false});
        },
        queryShiBaseData(data){
            return http.postJson('/big/front/queryShiBaseData', data, {loading: false});
        },
        queryShiRosterStuData(data){
            return http.postJson('/big/front/queryShiRosterStuData', data, {loading: false});
        },
        queryLessonData(data){
            return http.postJson('/big/front/queryLessonData', data, {loading: false});
        },
        queryRosterStuData(data){
            return http.postJson('/big/front/queryRosterStuData', data, {loading: false});
        },
        queryWeekStuData(data){
            return http.postJson('/big/front/queryWeekStuData', data, {loading: false});
        },
        queryLastData(data){
            return http.postJson('/big/front/queryLastData', data, {loading: false});
        },
        queryClassNumBySchool(data){
            return http.postJson('/big/front/queryClassNumBySchool', data, {loading: false});
        },
        queryRosterySchool(data){
            return http.postJson('/big/front/queryRosterySchool', data, {loading: false});
        },
        queryDataBySchool(data) {
            return http.json({
                url: `/big/front/queryDataBySchool`,
                data
            });
        },
        // queryDataBySchool(data){
        //     return http.postJson('/big/front/queryDataBySchool', data, {loading: false});
        // },
        queryTimeTableBySchool(data) {
            return http.json({
                url: `/big/front/queryTimeTableBySchool`,
                data
            });
        },
        // queryTimeTableBySchool(data){
        //     return http.postJson('/big/front/queryTimeTableBySchool', data, {loading: false});
        // },
        queryBmteacherClassNum(data) {
            return http.json({
                url: `/big/front/queryBmteacherClassNum`,
                data
            });
        },
        // queryBmteacherClassNum(data){
        //     return http.postJson('/big/front/queryBmteacherClassNum', data, {loading: false});
        // },
        querykcbmsss(data) {
            return http.json({
                url: `/big/front/querykcbmsss`,
                data
            });
        },
        // querykcbmsss(data){
        //     return http.postJson('/big/front/querykcbmsss', data, {loading: false});
        // },



        queryBmGradestuNum(data) {
            return http.json({
                url: `/big/front/queryBmGradestuNum`,
                data
            });
        },
        // queryBmGradestuNum(data){
        //     return http.postJson('/big/front/queryBmGradestuNum', data, {loading: false});
        // },
        queryGradeSsKcNum(data) {
            return http.json({
                url: `/big/front/queryGradeSsKcNum`,
                data
            });
        },
        // queryGradeSsKcNum(data){
        //     return http.postJson('/big/front/queryGradeSsKcNum', data, {loading: false});
        // },
        queryAll (data){
            return http
                .mock(function () {
                    let names = ['安西镇', '崇仙乡', '大阿镇', '大桥镇', '大塘埠镇', '古陂镇',
                        '虎山乡', '嘉定镇', '铁石口镇', '万隆乡', '西牛镇', '小河镇', '小江镇', '新田镇',
                        '信丰县工业园', '油山镇', '正平镇'
                    ];

                    return Utils.loopGenerate(names.length, function (index) {
                        return {
                            id: index,
                            name: names[index],
                            personal: Utils.getRandomByRegion(40000, 80000),
                            village: Utils.getRandomByRegion(300, 500),
                            work: Utils.getRandomByRegion(1500, 3000),
                            complete: Utils.getRandomByRegion(1, 100)
                        };
                    })
                })
                .postJson('/api/basic/queryAll', data);
        },

        queryMarker (data){
            return http
                .mock(function () {
                    let types = ['camera', 'trash', 'site'],
                        latLngList = [
                            ['114.714385', '25.40345'],
                            ['114.924155', '25.381118'],
                            ['114.801589', '25.308203'],
                            ['114.844504', '25.269711'],
                            ['115.066977', '25.207601'],
                            ['115.109549', '25.079555'],
                            ['114.812918', '25.10816'],
                            ['115.018912', '25.417404'],
                            ['115.099936', '25.345442'],
                            ['114.907676', '25.473595']
                        ];

                    return Utils.loopGenerate(latLngList.length, function (index) {
                        return {
                            id: index,
                            type: types[Utils.getRandomByRegion(0, 2)],
                            lat: latLngList[index][0],
                            lng: latLngList[index][1],
                        };
                    })
                })
                .postJson('/api/basic/queryMarker', data);
        },

        queryOnlineData (data){
            return http
                .mock(function () {
                    return {
                        onlineCar: 260,
                        totalClearKm: 1306,
                        onlinePersonal: 180,
                        totalGhKm: 900,
                        todayMarker: 400,
                        cql: 95
                    }
                })
                .postJson('/api/basic/queryOnlineData', data, {loading: false});
        },

        queryGhssData (data){
            return http
                .mock(function () {
                    return {
                        clearCarWeek: 324,
                        clearCarAverage: 175,
                        clearKmWeek: 236,
                        clearKmAverage: 215,
                        ghPersonalWeek: 215,
                        ghPersonalAverage: 301,
                        ghKmWeek: 265,
                        ghKmAverage: 226,
                        ghPointWeek: 290,
                        ghPointAverage: 126
                    }
                })
                .postJson('/api/basic/queryGhssData', data, {loading: false});
        },

        queryGhfwData (data){
            return http
                .mock(function () {
                    return [
                        {id: 1, name: '编程', num: 48},
                        {id: 2, name: '科学实验', num: 80},
                        {id: 3, name: '机器人搭建', num: 100},
                        {id: 4, name: '科普通识', num: 200},
                        {id: 5, name: '无人机基础1', num: 200},
                        {id: 6, name: '无人机基础2', num: 200},
                        {id: 7, name: '无人机基础3', num: 200},
                        {id: 8, name: '无人机基础4', num: 200},
                        {id: 9, name: '无人机基础5', num: 200},
                        {id: 10, name: '无人机基础6', num: 200},
                        {id: 11, name: '无人机基础7', num: 200},
                        {id: 12, name: '无人机基础8', num: 200},



                    ]
                })
                .postJson('/api/basic/queryGhfwData', data, {loading: false});
        },

        queryMapLines (data){
            return http
                .mock(function () {
                    return {
                        id: 1,
                        lines: [
                            // {fromName: '嘉定镇', toName: '嘉定镇', coords: [[114.933491,25.370173], [114.938984,25.376532]]},
                            {fromName: '古陂镇', toName: '嘉定镇', coords: [[115.099215,25.330052], [115.022755,25.427704]]},
                            {fromName: '大桥镇', toName: '嘉定镇', coords: [[115.153648,25.349878], [115.022755,25.427704]]},
                            {fromName: '新田镇', toName: '嘉定镇', coords: [[115.250866,25.359649], [115.022755,25.427704]]},
                            {fromName: '安西镇', toName: '嘉定镇', coords: [[115.068749,25.200341], [115.022755,25.427704]]},
                            {fromName: '小江镇', toName: '嘉定镇', coords: [[114.948393,25.089097], [115.022755,25.427704]]},
                            {fromName: '铁石口镇', toName: '嘉定镇', coords: [[114.929459,25.172877], [115.022755,25.427704]]},
                            {fromName: '大阿镇', toName: '嘉定镇', coords: [[114.82468,25.398111], [115.022755,25.427704]]},
                            {fromName: '油山镇', toName: '嘉定镇', coords: [[114.704995,25.408306], [115.022755,25.427704]]},
                            {fromName: '小河镇', toName: '嘉定镇', coords: [[114.842533,25.278125], [115.022755,25.427704]]},
                            {fromName: '西牛镇', toName: '嘉定镇', coords: [[114.88824,25.456299], [115.022755,25.427704]]},
                            {fromName: '正平镇', toName: '嘉定镇', coords: [[114.804377,25.316881], [115.022755,25.427704]]},
                            {fromName: '虎山乡', toName: '嘉定镇', coords: [[115.113854,25.07189], [115.022755,25.427704]]},
                            {fromName: '崇仙乡', toName: '嘉定镇', coords: [[114.819662,25.110224], [115.022755,25.427704]]},
                            {fromName: '万隆乡', toName: '嘉定镇', coords: [[114.794028,25.245709], [115.022755,25.427704]]},
                            {fromName: '信丰县工业园', toName: '嘉定镇', coords: [[114.917217,25.432324], [115.022755,25.427704]]},
                        ]
                    }
                })
                .postJson('/api/basic/queryMapLines', data, {loading: false});
        },

        queryGhfxData (data){
            return http
                .mock(function ({type}) {
                    let n = type === 'week' ? 1 : type === 'month' ? 4 : 48;

                    return [
                        {label: '奥数', value: 10},
                        {label: '科学实验', value: 9},
                        {label: '科普通识', value: 10},
                        {label: '基础编程', value: 11},
                        {label: '无人机基础', value: 12},
                        {label: '机器人搭建', value: 13},
                        {label: '人工智能', value: 18},
                        {label: '科学探索', value: 20},
                        {label: '图形化编程', value: 22},
                    ].map(item => Object.assign({}, item, {
                        value: item.value * n
                    }));
                })
                .postJson('/api/basic/queryGhfxData', data, {loading: false});
        },

        queryGdqkData(data) {
            return http
                .mock(function () {
                    let day = 15, km = 100;

                    return {
                        event: Utils.loopGenerate(day, function () {
                            return Utils.getRandomByRegion(500, 6000)
                        }),
                        work: Utils.loopGenerate(day, function () {
                            return Utils.getRandomByRegion(500, 6000);
                        }),
                        complaint: Utils.loopGenerate(day, function () {
                            return Utils.getRandomByRegion(500, 6000);
                        })
                    };
                }).postJson('/api/network/queryGdqkData', data, {loading: false});
        },

        queryGhzlData(data) {
            return http
                .mock(function () {
                    return {
                        wait: 5,
                        complaint: 2,
                        total: 70
                    };
                }).postJson('/api/network/queryGhzlData', data, {loading: false});
        },

        queryMonitorList(data) {
            return http
                .mock(function () {
                    return [
                        // {id: '1', name: '嘉定镇-水东村-村口主干道', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2021-04-13/190312083533415853.mp4'},
                        {id: '1', name: '嘉定镇-水东村-村口主干道', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2020-08-25/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4'},
                        // {id: '2', name: '嘉定镇-同益村-垃圾回收点', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2021-04-13/190319222227698228.mp4'},
                        {id: '2', name: '嘉定镇-同益村-垃圾回收点', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2020-08-25/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4'},
                        // {id: '3', name: '嘉定镇-山塘村-商业街', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2021-04-13/190204084208765161.mp4'},
                        {id: '3', name: '嘉定镇-山塘村-商业街', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2020-08-25/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4'},
                        // {id: '5', name: '嘉定镇-上七里村-村口监控', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2021-04-13/190318231014076505.mp4'},
                        {id: '5', name: '嘉定镇-上七里村-村口监控', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2020-08-25/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4'},
                        // {id: '4', name: '嘉定镇-黄家坑村-村委会', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2021-04-13/1618324014617334.mp4'}, //最好不用这个
                        {id: '4', name: '嘉定镇-黄家坑村-村委会', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2020-08-25/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4'}, //最好不用这个
                        // {id: '6', name: '嘉定镇-镇江村-活动中心', url: 'http://vjs.zencdn.net/v/oceans.mp4'},
                        {id: '6', name: '嘉定镇-镇江村-活动中心', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2020-08-25/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4'},
                        // {id: '7', name: '嘉定镇-柏树芫村-垃圾回收点', url: 'https://media.w3.org/2010/05/sintel/trailer.mp4'},
                        {id: '7', name: '嘉定镇-柏树芫村-垃圾回收点', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2020-08-25/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4'},
                        // {id: '8', name: '嘉定镇-上坑村-公交车站', url: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'}
                        {id: '8', name: '嘉定镇-上坑村-公交车站', url: 'https://file.hotec.cloud/jinhe/ykt-jh/2020-08-25/%E6%9C%AA%E5%91%BD%E5%90%8D.mp4'}
                    ]
                }).postJson('/api/network/queryMonitorList', data, {loading: false});
        },

        queryEvaluateData(data) {
            return http
                .mock(function () {
                    return {
                        gdzs: 2200,
                        czjsl: 95,
                        aqbjl: 98,
                        ghzyzs: 95,
                        bars: townList.map(item => Object.assign({}, {
                            name: item.name,
                            point: Utils.getRandomByRegion(300, 1000),
                            score: Utils.getRandomByRegion(300, 1000),
                            km: Utils.getRandomByRegion(300, 1000),
                        })),
                        bl: ['2020.01', '2020.02', '2020.03', '2020.04', '2020.05', '2020.06'].map(item => Object.assign({}, {
                            date: item,
                            today: Utils.getRandomByRegion(2000, 8000),
                            yesterday: Utils.getRandomByRegion(2000, 8000),
                        })),
                        rd: townList.map(item => Object.assign({}, {
                            text: item.name,
                            value: Utils.getRandomByRegion(2000, 5000)
                        }))
                    }
                }).postJson('/api/network/queryEvaluateData', data, {loading: false});
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/basic1.js